/**
 * @flow
 * @relayHash 2f6de63e01cbba36fe239ce1dec8d0bf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SubscriptionProductWhere = {|
  and?: ?$ReadOnlyArray<?SubscriptionProductWhere>,
  or?: ?$ReadOnlyArray<?SubscriptionProductWhere>,
  id?: ?ConditionInputType,
  productId?: ?ConditionInputType,
  subscriptionId?: ?ConditionInputType,
  price?: ?ConditionInputType,
  priceNet?: ?ConditionInputType,
  discountAmount?: ?ConditionInputType,
  rate?: ?ConditionInputType,
  qty?: ?ConditionInputType,
  subtotal?: ?ConditionInputType,
  totalDiscountAmount?: ?ConditionInputType,
  total?: ?ConditionInputType,
  totalNet?: ?ConditionInputType,
  mikrotikId?: ?ConditionInputType,
  macAddress?: ?ConditionInputType,
  wanMac?: ?ConditionInputType,
  ip?: ?ConditionInputType,
  leaseId?: ?ConditionInputType,
  queueId?: ?ConditionInputType,
  onuId?: ?ConditionInputType,
  catvStatus?: ?ConditionInputType,
  priceUsd?: ?ConditionInputType,
  priceNetUsd?: ?ConditionInputType,
  totalUsd?: ?ConditionInputType,
  totalNetUsd?: ?ConditionInputType,
  wlan?: ?ConditionInputType,
  stbNumber?: ?ConditionInputType,
  icCard?: ?ConditionInputType,
  subscriptionStatus?: ?ConditionInputType,
  oltId?: ?ConditionInputType,
  pon?: ?ConditionInputType,
  slot?: ?ConditionInputType,
  ponSn?: ?ConditionInputType,
  onuNumber?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type SubscriptionMacSearchQueryVariables = {|
  where?: ?SubscriptionProductWhere
|};
export type SubscriptionMacSearchQueryResponse = {|
  +SubscriptionProducts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +subscriptionId: string
      |}
    |}>
  |}
|};
export type SubscriptionMacSearchQuery = {|
  variables: SubscriptionMacSearchQueryVariables,
  response: SubscriptionMacSearchQueryResponse,
|};
*/


/*
query SubscriptionMacSearchQuery(
  $where: SubscriptionProductWhere
) {
  SubscriptionProducts(where: $where, first: 20) {
    edges {
      node {
        subscriptionId
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "SubscriptionProductWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subscriptionId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SubscriptionMacSearchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "SubscriptionProducts",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionProductConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "SubscriptionProductEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "SubscriptionProduct",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SubscriptionMacSearchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "SubscriptionProducts",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionProductConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "SubscriptionProductEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "SubscriptionProduct",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SubscriptionMacSearchQuery",
    "id": null,
    "text": "query SubscriptionMacSearchQuery(\n  $where: SubscriptionProductWhere\n) {\n  SubscriptionProducts(where: $where, first: 20) {\n    edges {\n      node {\n        subscriptionId\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '11d943ec661058cd6f7bd24ea93a82ec';
module.exports = node;
